import axios from "axios";
import { PATH } from "../data/apiPath";
import { clearEmptyProperty } from "../utils/helpers";

const getService = async (id = null) => {
    return await new Promise((resolve, reject) => {
        axios
            .get(`${PATH}/api/services/${id}`)
            .then((result) => resolve(result.data))
            .catch((error) => reject(error));
    });
};

const getServices = async (rules) => {
    return await new Promise((resolve, reject) => {
        let params = new URLSearchParams();
        let {
            limit = 200,
            page = 1,
            filters = {},
            search = "",
        } = rules && rules !== null ? rules : {};
        params.append("limit", limit);
        params.append("page", page);
        if (search && search !== "") params.append("search", search);
        const clearFilters = clearEmptyProperty(filters);
        if (Object.keys(clearFilters).length > 0)
            params.append("filters", JSON.stringify(clearFilters));
        axios
            .get(`${PATH}/api/services`, {
                params,
            })
            .then((result) => resolve(result.data))
            .catch((error) => reject(error));
    });
};

const getServicesCount = async (rules) => {
    return await new Promise((resolve, reject) => {
        let params = new URLSearchParams();
        let { filters = {}, search = "" } =
            rules && rules !== null ? rules : {};
        if (search && search !== "") params.append("search", search);
        const clearFilters = clearEmptyProperty(filters);
        if (Object.keys(clearFilters).length > 0)
            params.append("filters", JSON.stringify(clearFilters));
        axios
            .get(`${PATH}/api/servicesCount`, {
                params,
            })
            .then((result) => resolve(result.data))
            .catch((error) => reject(error));
    });
};

export { getService, getServices, getServicesCount };
